module.exports = __webpack_public_path__ + "static/about_kalendarz-0c2ed3be31489cda677372d27adb68dc.jpg";